import React from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "react-oidc-context";

import Loader from "../Loader/Loader";
import { hasLoaded } from "../../utils/loadingHelpers";
import { logout } from "../../utils/logout";
import { updateUserType } from "../../redux/EditorSlice";

const GlobalLayout = () => {
  const auth = useAuth();
  const dispatch = useDispatch();

  const { locale } = useParams();
  const { i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const school = useSelector((state) => state.school);

  useEffect(() => {
    // Clear location and current location from localStorage
    localStorage.removeItem("previousLocation");

    // Don't clear location if on user login page or if it's the page we're redirecting to (as this will also trigger a redirect)
    // This allows the user to return to the previous location after login with direct links
    const nextLocation = localStorage.getItem("location");
    if (
      !location?.pathname.includes("user_login/") &&
      location?.pathname !== nextLocation
    ) {
      localStorage.removeItem("location");
    }
  }, []);

  useEffect(() => {
    return auth.events?.addAccessTokenExpired(() => {
      logout(auth);
    }, [auth.events]);
  }, [auth]);

  useEffect(() => {
    if (auth?.user) {
      const scope = auth.user?.scope || "";
      if (scope.includes("student")) {
        dispatch(updateUserType("student"));
      }
    }
  }, [auth, dispatch]);

  useEffect(() => {
    const isValidLocale = i18n.options.locales.includes(locale);

    if (!isValidLocale) {
      const localeRegex = new RegExp(`^/${locale}`);
      navigate(location.pathname.replace(localeRegex, `/${i18n.language}`));
    }
  }, [locale, i18n, location, navigate]);

  return (
    <Loader loading={auth.isLoading || !hasLoaded(school?.loading)}>
      <Outlet />
    </Loader>
  );
};

export default GlobalLayout;
